import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import styled from 'styled-components';
import { SemanticCOLORS, SemanticICONS } from 'semantic-ui-react/dist/commonjs/generic';

const StatusIcon = styled.span`
  display: inline-block;
  width: 32px;
`;

const icons: Record<string, string> = {
  booth: 'browser',
  display: 'tv',
  kiosk: 'print',
  controlbox: 'server',
  cloudqsrv: 'cloud'
};

/**
 * `online` is the device-status endpoint's boolean: seen within the last-seen
 * TTL. There is no last-seen timestamp to grade against any more, so the icon
 * is green or red — never the old "never connected" third state.
 */
export function DeviceIcon(props: { online: boolean; deviceType?: string }) {
  const { online, deviceType } = props;
  const name = icons[String(deviceType).toLowerCase()] ?? 'question';
  const iconColor = online ? 'green' : 'red';
  return (
    <>
      <Popup
        trigger={
          <StatusIcon>
            <Icon name={online ? 'check' : 'broken chain'} size="large" color={iconColor as SemanticCOLORS} />
          </StatusIcon>
        }
      >
        {online ? 'Connected' : 'Disconnected'}
      </Popup>
      <Popup
        trigger={
          <StatusIcon>
            <Icon name={name as SemanticICONS} color={iconColor as SemanticCOLORS} size="large" />
          </StatusIcon>
        }
      >
        {deviceType}
      </Popup>
    </>
  );
}
